import React, { useEffect } from "react";
import { Hero, PromoSlider, HowItWorks } from "../components/home/HeroSections";
import { WhyChoose, Brands, Supplies } from "../components/home/ProductSections";
import { Testimonials, About, FAQ, Contact } from "../components/home/InfoSections";
import Nationwide from "../components/home/Nationwide";
import WatchLearn from "../components/home/WatchLearn";
import ContactStrip from "../components/home/ContactStrip";
import HolidayBanner from "../components/home/HolidayBanner";
import { useSite } from "../context/SiteContext";
import { usePageMeta, setJsonLd } from "../lib/seo";

const Home = () => {
  const { content } = useSite();
  usePageMeta({
    title: "StripWise | Free Quotes for Sealed, Unused Test Strips & Supplies",
    description: `Have sealed, unexpired testing supplies you no longer need? Get a free, no-obligation quote from StripWise, ship free with a prepaid label and get paid your way. Call ${content?.phone_display || ""}.`,
    path: "/",
  });
  useEffect(() => {
    if (window.location.pathname !== "/quote") return;
    const t = setTimeout(() => {
      document.querySelector("[data-testid=quote-form]")?.scrollIntoView({ behavior: "smooth", block: "center" });
      document.querySelector("[data-testid=quote-name]")?.focus({ preventScroll: true });
    }, 600);
    return () => clearTimeout(t);
  }, []);
  useEffect(() => {
    if (!content?.faqs) return;
    setJsonLd("ld-faq", {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: content.faqs.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
    });
  }, [content?.faqs]);
  return (
    <>
      <HolidayBanner />
      <Hero />
      <PromoSlider />
      <HowItWorks />
      <ContactStrip />
      <WatchLearn />
      <WhyChoose />
      <Brands />
      <Supplies />
      <Testimonials />
      <Nationwide />
      <About />
      <FAQ />
      <Contact />
    </>
  );
};

export default Home;
